export const commonSearch = (data,fieldNames,query) => {
    return data?.filter(row => {
        for (const fieldName of fieldNames) {
            const fieldValue = row[fieldName] ? row[fieldName].toString().toLowerCase() : '';
            if (fieldValue.includes(query.toLowerCase())) {
                return true;
            }
        }
        return false;
    });
}
